import PropTypes from "prop-types";
import ChatList from "../MessagesPage/components/ChatList";

export default function ReferralMemberMessages({ referral }) {
  const referralId = referral?._id;
  if (typeof referralId !== "string" || !/^[a-f\d]{24}$/i.test(referralId)) {
    return <p role="status" className="p-6 text-sm">Chat is unavailable until your referral member has a registered account.</p>;
  }
  const name = [referral.firstName, referral.lastName].filter(Boolean).join(" ");
  const context = `network:${referralId}`;
  const selectedContact = {
    jobId: context, jobTitle: "General conversation",
    participantDetails: { userId: referralId, _id: referralId, name,
      profilePic: referral.profilePic, referenceId: referral.refNo },
  };
  return <section aria-label="Current referral messages" className="flex flex-1 flex-col min-h-0">
    <div className="flex items-center gap-2 py-4 mb-4 border-b border-[#DDDDDD]">
      <div className="flex rounded-full h-12 w-12 bg-[#E1E0E0] items-center justify-center shrink-0">
        {referral.profilePic ? <img src={referral.profilePic} className="h-full w-full object-cover rounded-full" alt="Referral member" />
          : <span className="font-semibold text-white">{name.charAt(0)}</span>}
      </div>
      <p className="font-medium text-xl text-light-black">{name}</p>
    </div>
    <ChatList key={context} selectedContact={selectedContact} />
  </section>;
}

ReferralMemberMessages.propTypes = {
  referral: PropTypes.shape({ _id: PropTypes.string, firstName: PropTypes.string, lastName: PropTypes.string,
    profilePic: PropTypes.string, refNo: PropTypes.string }),
};
